import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL } from '../apiConfig'

export const fetchBranch = createAsyncThunk(
    'fetchBranch',
    async ({ jwtBearer }) => {
        const response = await fetch(`${BASE_URL}branch/get/all/data/`, {
            headers: {
                Authorization: `Bearer ${jwtBearer}` // Include the bearer token in the request header
            }
        })
        return response.json()
    }
)

const branchDataSlice = createSlice({
    name: 'branchDataSlice',
    initialState: {
        isLoading: false,
        data: null,
        isError: false
    },
    extraReducers: builder => {
        builder.addCase(fetchBranch.pending, (state, action) => {
            state.isLoading = true
        })
        builder.addCase(fetchBranch.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        })
        builder.addCase(fetchBranch.rejected, (state, action) => {
            console.log('Error', action.payload)
            state.isError = true
        })
    }
})

export default branchDataSlice.reducer
